module.exports = __webpack_public_path__ + "img/co2.406191fc.svg";